<template>
<div id="pageHome">
  <div id="active-page" :class="{'page-fade': !mountedPage}"></div>
  <section>
    <h1 class="mb-neg">{{$t('titles.addMedias')}}</h1>
    <div id="contain-img">
      <v-img
        :title="$t('titles.addMedias')"
        contain
        :src="require('@/assets/img/upload_img_logo.png')"
        @click="promptFile"
        max-width="400"
        class="img-prompt"
      ></v-img>
    </div>
  </section>
  <section>
    <h1>{{$t('titles.latestProjects')}}</h1>
    <latestProjects class="pt-0"/>
  </section>
</div>
</template>

<script>
import headernav from "@/components/layouts/header.vue";
import contentnew from "@/components/content.vue";
import user_componentVue from "../../components/user/user_component.vue";
import latestProjects from "../page-directories/latest-directories.vue";
import searchedProjects from "../page-directories/search-directories.vue";
import modalNewimageVue from "../../components/modals-form/modal-newimage.vue";

export default {
  props: {
    source: String
  },
  components: {
    user_componentVue,
    headernav,
    modalNewimageVue,
    latestProjects,
    searchedProjects,
    contentnew
    // newproject,
  },
  data() {
    return {
      // small: false,
      search: "",
      // projects: [],
      mountedPage: false
    };
  },
  computed: {
    user() {
      return this.$store.state.authentication.user;
    },
    created() {
      this.$store.dispatch("users/getAll");
    },
    filter(search) {
      //return this.projects.filter( project => project.name == search);
    }
  },
  methods: {
    promptFile() {
      let inputFile = document.getElementById('input-file');
      inputFile.click();
    },
    getAllProjects() {
      this.projects = this.$store.getters["project/getProjectsAnyParent"];
      
    },
    toggleNewImg() {
      this.$store.dispatch("dialogModal/toggleModalImg");
    },
    handleResize() {
      let sm = window.matchMedia("(max-width: 700px)");
      if (sm.matches) {
        this.small = true;
      } else {
        this.small = false;
      }
    }
  },
  created() {
    this.$store.dispatch("users/getAll");
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    setTimeout(() => this.mountedPage = true, 100);
  }
};
</script>

<style>
#pageHome .contain-img {
  margin-bottom: -5rem;
}
#active-page{
  visibility: hidden;
  opacity: 0;
  width: 100%;
  top: 0;
  bottom: 0;
  position: absolute;
  z-index: 2;
  background: #171717;
  transition: visibility ease .5s, opacity ease .5s;
}
#active-page.page-fade {
  visibility: visible;
  opacity: 1;
}
.title-bord {
  border-top: 1px solid white;
  padding-top: 2rem;
}
.img-prompt {
  cursor: pointer;
  margin: auto;
  margin-bottom: 2rem;
}
.img-prompt:hover {
  box-shadow:  0 0 5px rgba(0, 0, 0, .6);
}
.mb-neg {
  margin-bottom: -3rem;
}
</style>
